import injectionHelpers from '@carwow/injection-rules-helpers';

import config from '@carwow/injection-default-config';

export default [
  {
    id: 'digiteka-desktop',
    componentType: 'digitekaDesktop',
    condition: (options) => injectionHelpers.shouldInjectDigiteka({ options, viewport: 'desktop' }),
    component: ({
      monetising, breakpoints, localConfig = {},
    }) => injectionHelpers.getConfig({
      localConfig,
      ruleName: 'digiteka-desktop',
      props: { monetising, breakpoints, viewport: 'desktop' },
      defaultConfig: config.getDigitekaConfig({ monetising, breakpoints, viewport: 'desktop' }),
    }),
  },
  {
    id: 'digiteka-mobile',
    componentType: 'digitekaMobile',
    condition: (options) => injectionHelpers.shouldInjectDigiteka({ options, viewport: 'mobile' }),
    component: ({
      monetising, breakpoints, amp, localConfig = {},
    }) => injectionHelpers.getConfig({
      localConfig,
      ruleName: 'digiteka-mobile',
      props: {
        monetising, breakpoints, viewport: 'mobile', amp,
      },
      defaultConfig: config.getDigitekaConfig({
        monetising, breakpoints, viewport: 'mobile', amp,
      }),
    }),
  },
];
